import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["match", "counter", "prevButton", "nextButton"]
  static values = {
    currentIndex: { type: Number, default: 0 }
  }

  declare readonly matchTargets: HTMLElement[]
  declare readonly counterTarget: HTMLElement
  declare readonly prevButtonTarget: HTMLButtonElement
  declare readonly nextButtonTarget: HTMLButtonElement
  declare currentIndexValue: number

  connect() {
    this.showCurrentMatch()
  }

  next() {
    if (this.currentIndexValue < this.matchTargets.length - 1) {
      this.currentIndexValue++
      this.showCurrentMatch()
    }
  }

  previous() {
    if (this.currentIndexValue > 0) {
      this.currentIndexValue--
      this.showCurrentMatch()
    }
  }

  private showCurrentMatch() {
    // Hide all matches
    this.matchTargets.forEach((match, index) => {
      if (index === this.currentIndexValue) {
        match.classList.remove('hidden')
      } else {
        match.classList.add('hidden')
      }
    })

    // Update button states
    this.updateButtonStates()
  }

  private updateButtonStates() {
    // Previous button
    if (this.currentIndexValue === 0) {
      this.prevButtonTarget.disabled = true
      this.prevButtonTarget.classList.remove('bg-white', 'border-gray-300', 'text-gray-700', 'hover:bg-gray-50')
      this.prevButtonTarget.classList.add('bg-gray-100', 'border-gray-200', 'text-gray-400', 'cursor-not-allowed')
    } else {
      this.prevButtonTarget.disabled = false
      this.prevButtonTarget.classList.remove('bg-gray-100', 'border-gray-200', 'text-gray-400', 'cursor-not-allowed')
      this.prevButtonTarget.classList.add('bg-white', 'border-gray-300', 'text-gray-700', 'hover:bg-gray-50')
    }

    // Next button
    if (this.currentIndexValue === this.matchTargets.length - 1) {
      this.nextButtonTarget.disabled = true
      this.nextButtonTarget.classList.remove('bg-white', 'border-gray-300', 'text-gray-700', 'hover:bg-gray-50')
      this.nextButtonTarget.classList.add('bg-gray-100', 'border-gray-200', 'text-gray-400', 'cursor-not-allowed')
    } else {
      this.nextButtonTarget.disabled = false
      this.nextButtonTarget.classList.remove('bg-gray-100', 'border-gray-200', 'text-gray-400', 'cursor-not-allowed')
      this.nextButtonTarget.classList.add('bg-white', 'border-gray-300', 'text-gray-700', 'hover:bg-gray-50')
    }
  }
}
